import { _types } from './constant'
import api from '@/api'

const state = {
    storeSpeed: {}
};

const getters = {
    [_types.getters.GET_STORE_SPEED](state) {
        return state.storeSpeed
    }
};

const actions = {
    async [_types.actions.START_TRIAL]({}, payload){
        try {
            return await api.startTrial(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_STORE_SPEED]({ commit }, payload) {
        try {
            let res = await api.getStoreSpeed(payload)
            let { status = false, data = null } = res.data
            if (status) {
                commit(_types.mutations.SET_STORE_SPEED, data)
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_SPEED_SUMMARY_RESYNC]({ commit }, payload) {
        try {
            let res = await api.getSpeedSummaryResync(payload)
            let { status = false, data = null } = res.data
            if (status) {
                commit(_types.mutations.SET_STORE_SPEED, data)
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_CHECK_SYNC_SPEED_SUMMARY]({ }, payload) {
        try {
            return await api.getCheckSyncSpeedSummary(payload)
        } catch (error) {
            throw error;
        }
    },
};

const mutations = {
    [_types.mutations.SET_STORE_SPEED](state, payload = []) {
        state.storeSpeed = payload
    }
};
export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};